module.exports = __webpack_public_path__ + "cebe8b2c261a05ba9b6732bb3ae9843b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/images/avatar-sharon.svg
// module id = ./src/components/Home/images/avatar-sharon.svg
// module chunks = 2